import React from "react";

const MemberIdCard = ({ user }) => {
  return <div>MemberIdCard</div>;
};

export default MemberIdCard;
